var map = {
	"./img/clients-items/mgu/mgu-video.webm": 1364,
	"./img/completo/msu-video.webm": 2132,
	"./img/msu/msu-video.webm": 2142,
	"./video/mts-main-products-boards.webm": 2288,
	"./video/mts-main-products-chats.webm": 2289,
	"./video/mts-main-products-comdi.webm": 2290,
	"./video/mts-main-products-courses.webm": 2291,
	"./video/mts-main-products-equipment.webm": 2292,
	"./video/mts-main-products-forms.webm": 2293,
	"./video/mts-main-products-meetings.webm": 2294,
	"./video/mts-main-products-webinars.webm": 2295,
	"./video/mts-products-chats-account-management.webm": 2296,
	"./video/mts-products-chats-adding-employees.webm": 2297,
	"./video/mts-products-chats-ai-assistant.webm": 2298,
	"./video/mts-products-chats-appointment-moderators.webm": 2299,
	"./video/mts-products-chats-chats-and-channels.webm": 2300,
	"./video/mts-products-chats-distribution-groups.webm": 2301,
	"./video/mts-products-chats-favorite-features.webm": 2302,
	"./video/mts-products-chats-in-platform.webm": 2146,
	"./video/mts-products-chats-one-click-call.webm": 2303,
	"./video/mts-products-chats-promo-mobile.webm": 2147,
	"./video/mts-products-chats-promo.webm": 2195,
	"./video/mts-products-comdi.webm": 2115,
	"./video/webinars-detail/auto-webinars.webm": 2304,
	"./video/webinars-detail/banners.webm": 2305,
	"./video/webinars-detail/branding.webm": 2306,
	"./video/webinars-detail/engagement-monitoring.webm": 2307,
	"./video/webinars-detail/groups.webm": 2308,
	"./video/webinars-detail/metrics.webm": 2309,
	"./video/webinars-detail/participant-testing.webm": 2310,
	"./video/webinars-detail/questions-sorting.webm": 2311,
	"./video/webinars-detail/simple-interface.webm": 2312,
	"./video/webinars-detail/sync-translation.webm": 2313,
	"./video/webinars-detail/technical-support.webm": 2314,
	"./video/webinars-detail/tests-and-surveys.webm": 2315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1366;